/* Back-in-stock waitlist: shows the form when the selected variant is sold
   out, posts the request to the ssc-account Worker via the app proxy. */
(function () {
  'use strict';
  var form = document.querySelector('[data-ssc-waitlist]');
  if (!form) return;
  var PROXY = '/apps/ssc';
  var msg = form.querySelector('.ssc-waitlist-msg');
  var input = form.querySelector('input[name="email"]');
  var button = form.querySelector('button[type="submit"]');

  function sync(variant) {
    if (variant) {
      form.setAttribute('data-variant-id', variant.id);
      form.setAttribute('data-variant-title', variant.title || '');
      form.setAttribute('data-available', String(!!variant.available));
    }
    var available = form.getAttribute('data-available') === 'true';
    form.hidden = available;
    if (!available) { form.classList.remove('is-done'); msg.hidden = true; }
  }

  document.addEventListener('ssc:variant-changed', function (ev) {
    sync(ev.detail && ev.detail.variant);
  });
  sync(null);

  function show(text, isError) {
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
    msg.hidden = false;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show('That email does not look right.', true); return; }
    button.disabled = true;
    fetch(PROXY + '/waitlist', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        handle: form.getAttribute('data-handle'),
        title: form.getAttribute('data-title'),
        variantId: form.getAttribute('data-variant-id'),
        variantTitle: form.getAttribute('data-variant-title'),
        url: window.location.pathname
      })
    }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { show('Could not save that right now. Try again in a minute.', true); return; }
        form.classList.add('is-done');
        show(res.body.already ? 'You are already on the list for this one. We will write the day it is back.' : 'Noted. We will email you the day it is back in stock.');
      })
      .catch(function () { show('Could not save that right now. Try again in a minute.', true); })
      .then(function () { button.disabled = false; });
  });
})();
